<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
    <el-form label-position="left" ref="ChangeClassificationNameForm" :rules="rule" label-width="80px"
             :model="changeClassificationNameForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 class="acr-dialog-title">修改分类信息</h1>
        <div class="acr-dialog-form">
          <el-form-item label="ID" prop="id">
            <el-input v-model="changeClassificationNameForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="分类名" prop="name">
            <el-input v-model="changeClassificationNameForm.name"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doEditClassification">提交</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";

export default {
  name: "EditClassificationDialog",
  data() {
    const validateId = (rule, value, callback) => {
      if (value !== this.bufferId) {
        callback(new Error("????"))
      }
      callback();
    }
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新的分类名'))
      } else {
        if (value === this.bufferName) {
          callback(new Error('新的分类名不能与原分类名相同'));
        } else {
          if (value.length < 2 || value.length > 6) {
            callback(new Error('请输入正确格式的分类名长度[2-6]'));
          }
        }
        callback();
      }
    }
    return {
      dialogFormVisible: false,
      changeClassificationNameForm: {
        id: '',
        name: ''
      },
      rule: {
        id: [
          {validator: validateId, trigger: 'blur'}
        ],
        name: [
          {validator: validateName, trigger: 'blur'}
        ]
      },
      bufferId: '',
      bufferName: '',
    }
  },
  methods: {
    doEditClassification() {
      this.$refs['ChangeClassificationNameForm'].validate((valid) => {
        if (valid) {
          AxiosBase.axiosPost("/curriculum-ad/edit-classification", this.changeClassificationNameForm).then(response => {
            if (response !== 0) {
              this.$parent.getClassificationData();
              this.$refs['ChangeClassificationNameForm'].resetFields();
              this.dialogFormVisible = false;
              Message({
                showClose: true,
                message: '修改分类信息成功',
                type: 'success'
              });
            }
          })
        }
      });
    },
  }
}
</script>

